import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  showMoreText: theme => ({
    color: theme.colors.showMoreColor,
    fontFamily: Fonts.type.VFFont,
    fontSize: 16.7,
    textAlign: 'center',
    marginTop: 20,
  }),
  divider: theme => ({
    marginTop: 16,
    borderBottomColor: theme.colors.VFDivider.tertiary,
    borderBottomWidth: 1,
  }),
});
